if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        if (!config || !config.headers) {
          console.error('fetchConfig 返回无效配置');
          return;
        }
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        if (!window.routes || !window.routes.cart_add_url) {
          console.error('routes.cart_add_url 未定义');
          return;
        }

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => {
            // 401/403/500 等可能返回非 JSON 或空 body，先取文本再安全解析
            return response.text().then((text) => {
              let data = null;
              try {
                data = text ? JSON.parse(text) : {};
              } catch (_) {
                data = { status: response.status, description: response.statusText || 'Request failed' };
              }
              // 非 2xx 且无业务错误体时，补全为错误结构
              if (!response.ok && data && data.status === undefined) {
                data.status = response.status;
                if (!data.description) data.description = response.status === 401 ? 'Unauthorized' : 'Request failed';
              }
              return { response, data, ok: response.ok };
            });
          })
          .then(({ response: res, data: response, ok }) => {
            // 非 2xx：本地 / 预览环境可能无法真正写入购物车（例如 401 Unauthorized）
            // 这里只在商品页提示错误，不再跳转到空购物车，也不抛 JS 异常
            if (!ok) {
              let msg;
              if (res.status === 401 || res.status === 403) {
                msg =
                  response?.description ||
                  '当前本地预览环境未授权，暂时无法添加到购物车，请在正式站点或已登录预览链接中测试。';
              } else {
                msg =
                  response?.description ||
                  res.statusText ||
                  `Add to cart 请求失败（HTTP ${res.status}）`;
              }
              // 仅在主题编辑器中输出详细调试信息，避免正常预览时出现“报错感”
              if (window.Shopify?.designMode) {
                console.info('[Add to cart] request failed', {
                  status: res.status,
                  url: res.url,
                  response,
                });
              }
              this.handleErrorMessage(msg);
              this.error = true;
              return;
            }
            if (response.status) {
              if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
                publish(window.PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage || !this.submitButtonText) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (window.routes && window.routes.cart_url) {
                window.location = window.routes.cart_url;
              }
              return;
            }

            const startMarker = window.CartPerformance?.createStartingMarker?.('add:wait-for-subscribers');
            if (!this.error && window.PUB_SUB_EVENTS && typeof publish === 'function') {
              publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                if (startMarker && window.CartPerformance?.measureFromMarker) {
                  window.CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (window.CartPerformance?.measure && this.cart?.renderContents) {
                      window.CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    } else if (this.cart?.renderContents) {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              if (typeof quickAddModal.hide === 'function') {
                quickAddModal.hide(true);
              }
            } else {
              if (window.CartPerformance?.measure && this.cart?.renderContents) {
                window.CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              } else if (this.cart?.renderContents) {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden');
            }

            if (window.CartPerformance?.measureFromEvent) {
              window.CartPerformance.measureFromEvent("add:user-action", evt);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText && window.variantStrings) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
